export default class Util {
	/*
	 * returns Prefix + Fullname of the contact
	 * @param {Prefix} string with prefix of the contact
	 * @param {Contact} object with contact data
	 */
	static getContactFullName = (Prefix, Contact) => {
		const {
			FirstName = '',
			MiddleName = '',
			LastName = '',
			Suffix = '',
		} = Contact;

		return `${Prefix} ${FirstName}${MiddleName && ` ${MiddleName}`}${`${
			LastName && ` ${LastName}`
		}${`${Suffix && ` ${Suffix}`}`}`}`
			.replace('-None-', '')
			.trim();
	};
}
